import { Box, Paper, Typography, useTheme, useMediaQuery } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from 'recharts';
import { formatMoney } from '../utils/reportesData';

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const item = payload[0];
  return (
    <Paper sx={{ p: 1.5, boxShadow: 3 }}>
      <Typography variant="caption" fontWeight={700} display="block">
        {label}
      </Typography>
      <Typography variant="body2" color="primary">
        Bs. {formatMoney(item.value)}
      </Typography>
    </Paper>
  );
}

export default function ReporteChart({ periodos, metricKey, metricLabel, isProductSnapshot }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const data = (periodos || []).map((p) => ({
    name: p.label,
    value: parseFloat(p[metricKey]) || 0,
  }));

  if (data.length === 0) {
    return (
      <Paper variant="outlined" sx={{ p: 4, mb: 3, textAlign: 'center' }}>
        <Typography color="text.secondary">
          No hay datos para mostrar en el gráfico con los filtros seleccionados.
        </Typography>
      </Paper>
    );
  }

  const title = isProductSnapshot
    ? `Valor de inventario por material`
    : `${metricLabel} por período`;

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
      <Typography variant="subtitle1" fontWeight={700} mb={2}>
        {title}
      </Typography>
      <Box sx={{ width: '100%', height: isMobile ? 280 : 360 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 20, right: 8, left: 8, bottom: isMobile ? 60 : 40 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="name"
              tick={{ fontSize: isMobile ? 10 : 12 }}
              angle={isMobile ? -45 : data.length > 6 ? -30 : 0}
              textAnchor={isMobile || data.length > 6 ? 'end' : 'middle'}
              interval={0}
              height={isMobile ? 70 : 50}
            />
            <YAxis
              tick={{ fontSize: 11 }}
              tickFormatter={(v) =>
                v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v.toFixed(0)
              }
            />
            <Tooltip content={<ChartTooltip />} />
            <Bar dataKey="value" fill="#1976d2" radius={[4, 4, 0, 0]} maxBarSize={64}>
              <LabelList
                dataKey="value"
                position="top"
                formatter={(v) => (v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v.toFixed(0))}
                style={{ fontSize: 10, fill: '#424242' }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
}
